/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IssuerNamesResponse
 */
export interface IssuerNamesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof IssuerNamesResponse
     */
    issuerNames?: Array<string>;
}

/**
 * Check if a given object implements the IssuerNamesResponse interface.
 */
export function instanceOfIssuerNamesResponse(value: object): boolean {
    return true;
}

export function IssuerNamesResponseFromJSON(json: any): IssuerNamesResponse {
    return IssuerNamesResponseFromJSONTyped(json, false);
}

export function IssuerNamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssuerNamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'issuerNames': json['issuerNames'] == null ? undefined : json['issuerNames'],
    };
}

export function IssuerNamesResponseToJSON(value?: IssuerNamesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'issuerNames': value['issuerNames'],
    };
}

